import {useState, useEffect} from 'react';

/**
 * Manages empty state display with delay
 */
export const useEmptyState = (loading, productsLength, delay = 500) => {
	const [showEmpty, setShowEmpty] = useState(false);

	useEffect(() => {
		if (!loading && productsLength === 0) {
			const timer = setTimeout(() => setShowEmpty(true), delay);
			return () => clearTimeout(timer);
		} else {
			setShowEmpty(false);
		}
	}, [loading, productsLength, delay]);

	return showEmpty;
};